var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shadow-box',{attrs:{"status":_vm.innerStatus,"zIndex":_vm.zIndex}},[_c('transition-fade',[(_vm.innerStatus)?_c('div',{staticClass:"modal-container"},[_vm._t("default")],2):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }